import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    modalId: String
  }

  connect() {
    // This controller is attached to the trigger button
  }

  open(event) {
    event.preventDefault()

    // Find the modal by ID
    const modalId = this.modalIdValue
    const modal = document.getElementById(modalId)

    if (modal) {
      // Dispatch a custom event on the modal element
      const event = new CustomEvent('modal:open')
      modal.dispatchEvent(event)
    } else {
      console.error("Modal element not found with ID:", modalId)
    }
  }
}
